const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export function retry<T, U extends (...args: any) => any>(
  promiseCreator: (...args: Parameters<U>) => Promise<T>,
  retries: number,
  ...args: Parameters<U>
): Promise<T> {
  return new Promise((resolve, reject) => {
    promiseCreator(...args)
      .then((value) => resolve(value))
      .catch((reason) => {
        if (retries <= 0) {
          reject(new Error(`Niet gelukt om promise te resolven door fout: ${reason}`));
        } else {
          delay(100)
            .then(() => retry(promiseCreator, --retries, ...args))
            .then(resolve)
            .catch(reject);
        }
      });
  });
}
